
import React, { useEffect, useState, } from "react";
import { Form, Input, Select, Button, Space } from "antd";
import { CancelButton, SaveButton, ModalComponent } from "@comps/components";
import { makeRequest, getErrorProps, notify } from "@utils/helpers";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { updateInvoiceAddonReq } from "./requests";

const formName = "updateInvoiceAddon";

const UpdateInvoiceAddon = (props) => {
  const [loader, setLoader] = useState(false);

  const onFinish = (data) => {
    let payload = { "addons": data.option_details }
    payload.id = props.data.id
    makeRequest(setLoader, updateInvoiceAddonReq, payload, onSuccess, onError);
  }

  const onSuccess = (data, res) => {
    notify("Invoice Additional", res.msg);
    props.onCreated(data);
  }

  const onError = (err) => {
    notify("Invoice Additional", "Something went wrong");
  }

  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------
  const footer = [
    <SaveButton style={ { background: props.crmStyle.bg_color, border: props.crmStyle.border_color } } form={ formName } key="create_button" htmlType="submit" state={ loader } />,
    <CancelButton key="close_button" onClick={ () => props.onCreated(false) } />
  ];
  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------

  return (

    <ModalComponent width={ 700 } mainTitle="Update" subTitle="ADDITIONAL FEE" visible={ true } footer={ footer } onCancel={ () => props.onCreated(false) } >

      <Form
        layout="vertical"
        name={ formName }
        onFinish={ onFinish }
      >
        <Form.List
          name="option_details"
          initialValue={ [
            { title: props.data.title, amount: props.data.amount, is_paid: props.data.is_paid },
          ] }
        >
          { (fields, { add, remove }) => (
            <>
              { fields.map(({ key, name, ...restField }) => (
                <Space key={ key } style={ { display: "flex", marginBottom: 8 } } align="baseline">
                  <Form.Item { ...restField } name={ [name, "title"] } rules={ [{ required: true, message: "Please Enter Title" }] }>
                    <Input placeholder="Title" />
                  </Form.Item>
                  <Form.Item { ...restField } name={ [name, "amount"] } rules={ [{ required: true, message: "Please Enter Amount" }] }>
                    <Input type="number" placeholder="Amount" />
                  </Form.Item>
                  <Form.Item { ...restField } name={ [name, "is_paid"] }>
                    <Select
                      style={ { width: 150 } }
                      showSearch
                      filterOption={ (d1, d2) => d2?.label && d2.label.toLocaleString().toLowerCase().indexOf(d1.toLowerCase()) >= 0 }
                      placeholder="Select Status"
                      options={ [{ "value": 1, "label": "Paid" }, { "value": 0, "label": "Unpaid" }] }
                    />
                  </Form.Item>
                  { fields && fields.length > 1 ? <MinusCircleOutlined onClick={ () => remove(name) } /> : null }
                </Space>
              )) }
              <Form.Item>
              </Form.Item>
            </>
          ) }
        </Form.List>


      </Form>
    </ModalComponent>
  );

}
const rules = {
  title: [
    { required: true, message: 'Please input title!', },
  ],

};


export default UpdateInvoiceAddon